import { ComputedRef, InjectionKey, Ref } from 'vue';

/** Map from column names to friendly display names */
export const ProvidedColumnToFriendlyNameMap: InjectionKey<
  ComputedRef<Record<string, string>>
> = Symbol('ProvidedColumnToFriendlyNameMap');

/** Data templates configuration */
export const ProvidedTemplates: InjectionKey<Ref<unknown[]>> =
  Symbol('ProvidedTemplates');

/** Map from template type to fields */
export const ProvidedTemplateToFieldMap: InjectionKey<
  Ref<Record<string, unknown[]>>
> = Symbol('ProvidedTemplateToFieldMap');

/** Metadata for templates with unsatisfied requirements */
export const ProvidedUnsatisfiedTemplateMetadata: InjectionKey<Ref<unknown[]>> =
  Symbol('ProvidedUnsatisfiedTemplateMetadata');

/** The CRM type (e.g., 'salesforce', 'hubspot') */
export const ProvidedCrm: InjectionKey<string> = Symbol('ProvidedCrm');
